import '@firebase/analytics-compat';
//# sourceMappingURL=index.esm.js.map



//////////////////
// WEBPACK FOOTER
// ./~/firebase/compat/analytics/dist/index.esm.js
// module id = 578
// module chunks = 14